import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { JourneyType } from '../../../../../__generated__/globalTypes';
import urlMinify from '../../../../../common/utils/urlMinify';
import useOrderOnline from '../../../../hooks/queries/useOrderOnline';
import { useBasketInitV3 } from '../../../../hooks/useBasketInitV3';
import { IButtonClickAction } from '../../../presentational/actionButtons/ActionButtons';
import Submit from '../../../presentational/actionButtons/customiseSubmit/Submit';
import IActionButtonProps from '../IActionButtonProps';

const OrderOnlineButtonContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  const { getBasketInitV3Data } = useBasketInitV3(JourneyType.reserve_online);
  const basketInitV3Data = getBasketInitV3Data();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [configurationSourceUrl, setConfigurationSourceUrl] = useState('');
  const { data, loading, loadOrderOnline } = useOrderOnline(configurationSourceUrl);
  const buttonIsDisabled = isSubmitting || loading || config.disabled;

  const minifiedConfigurationUrl = useCallback(async () => {
    const tinyUrl = await urlMinify.shorten(basketInitV3Data.configurationSourceUrl);
    setConfigurationSourceUrl(tinyUrl);
  }, [basketInitV3Data]);

  useEffect(() => {
    if (!configurationSourceUrl) {
      minifiedConfigurationUrl();
    }

    if (!loading && data) {
      setIsSubmitting(true);
      window.location.href = data.orderOnlineExternal;
      return;
    }
  }, [loading, minifiedConfigurationUrl, data]);

  const onClick: IButtonClickAction = useCallback(() => {
    loadOrderOnline();
  }, [config.isOrderOnlineEnabled]);

  return <Submit onClick={onClick} disabled={buttonIsDisabled} loading={loading || isSubmitting} />;
};

export default OrderOnlineButtonContainer;
